import React from "react";

export default function ArrowRight() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M8.29958 11.8991L11.7356 8.67361H2.65077C2.28634 8.67361 2 8.39203 2 8.03364C2 7.67526 2.28634 7.39367 2.65077 7.39367H11.7615L8.29928 4.09128C8.03897 3.83529 8.03897 3.45131 8.27325 3.19532C8.53355 2.93933 8.92402 2.93933 9.18432 3.16972L13.8178 7.57272C13.8438 7.59831 13.8698 7.62391 13.8698 7.64951L13.8959 7.67511C13.974 7.77751 14 7.9055 14 8.03349V8.08469V8.16149C14 8.18709 13.974 8.23829 13.974 8.26388C13.974 8.26388 13.974 8.28948 13.9479 8.28948C13.9219 8.31508 13.9219 8.34068 13.8959 8.36628C13.8959 8.39188 13.8698 8.39188 13.8698 8.39188C13.8438 8.41748 13.8438 8.44308 13.8178 8.44308L9.18432 12.8203C8.92402 13.0763 8.50752 13.0507 8.27325 12.7947C8.01294 12.5643 8.03927 12.1551 8.29958 11.8991Z' />
    </svg>
  );
}
